// extracted by mini-css-extract-plugin
export var headerCell = "_53-1";
export var loadingSpinnerContainer = "_53-4";
export var rowWrapper = "_53-3";
export var standaloneTable = "_53-5";
export var table = "_53-0";
export var white = "_53-2";